module.exports = __webpack_public_path__ + "img/test.2d371452.png";